export const NPS_SUMMARY_REPORT = 'NPS Summary Report V4';
export const NPS_SUMMARY_REPORT_MESSAGE =
  'Displays the NPS Summary Report V4 for the date range provided';
export const NPS_SUMMARY_REPORT_TITLE = "npsSummaryReportV4";

export const groupingOptions = ['Week', 'Month', 'Year'];
export const highlightedFields = [
  'totalResponses',
  'totalResponsesPercentage',
  'totalRows',
  'npsScore',
  'detractor',
  'detractorPercentage',
  'passive',
  'passivePercentage',
  'promotor',
  'promotorPercentage',
 ] as const;

export const newColumns = [
  { name: 'siteName', title: 'Repairer Name' },
  { name: 'totalRows', title: 'Total Surveys' },
  {
    title: 'Total Response',
    children: [
      {
        name: 'totalResponses',
        title: 'Count',
      },
      {
        name: 'totalResponsesPercentage',
        title: '%',
      },
    ],
  },
  {
    title: 'Detractor',
    children: [
      {
        name: 'detractor',
        title: 'Count',
      },
      {
        name: 'detractorPercentage',
        title: '%',
      },
    ],
  },
  {
    title: 'Passive',
    children: [
      {
        name: 'passive',
        title: 'Count',
      },
      {
        name: 'passivePercentage',
        title: '%',
      },
    ],
  },
  {
    title: 'Promotor',
    children: [
      {
        name: 'promotor',
        title: 'Count',
      },
      {
        name: 'promotorPercentage',
        title: '%',
      },
    ],
  },
  { name: 'npsScore', title: 'NPS Score' },
  { name: 'repairerGroup', title: 'Repairer Group', width: '150' },
];

export const summaryItems = [
  { columnName: 'siteName', type: 'sum', customizeText: () => `Grand Total` },
  { columnName: 'totalRows', type: 'sum' },
  { columnName: 'totalResponses', type: 'sum' },
  { columnName: 'totalResponsesPercentage', type: 'custom' },
  { columnName: 'detractor', type: 'sum' },
  { columnName: 'detractorPercentage', type: 'custom' },
  { columnName: 'passive', type: 'sum' },
  { columnName: 'passivePercentage', type: 'custom' },
  { columnName: 'promotor', type: 'sum' },
  { columnName: 'promotorPercentage', type: 'custom' },
  { columnName: 'npsScore', type: 'custom' },
];

export const reportsColors = {
  totalRows: 'fa8072',
  totalResponses: 'f5f5f5',
  totalResponsesPercentage: 'f5f5f5',
  detractor: 'ffe4e1',
  detractorPercentage: 'ffe4e1',
  promotor: '20b2aa',
  promotorPercentage: '20b2aa',
  passive: 'fffacd',
  passivePercentage: 'fffacd',
  npsScore: 'fffff0',
  npsScoreRange1: '90EE90', //Above 25
  npsScoreRange2: 'FFA500', //0 to 25
  npsScoreRange3: 'FFC0CB', //Negative Numbers
};

// TODO: remove after testing
export const mockedData = [
  {
    schemecode: "DLG2024",
    siteName: "DLG Auto Services (Heywood)",
    siteCode: "DLG_HEY",
    noResponse: 5,
    detractor: 1,
    passive: 2,
    promotor: 3,
    groupingValue: "Group A",
    totalResponses: 5,
    totalRows: 6,
    dateStarted: "2024-01-01T08:00:00Z",
    dateEnded: "2024-06-30T17:00:00Z",
    npsScore: 33,
    monthYearGroupings: [
      {
        name: "2024/27",
        value: 1
      },
      {
        name: "2024/28",
        value: 4
      },
      {
        name: "2025/06",
        value: 2
      },
      {
        name: "2025/40",
        value: 2
      },
      {
        name: "2025/41",
        value: 1
      },
      {
        name: "2025/45",
        value: 3
      }
    ],
    repairerGroup: "DLGAS"
  },
  {
    schemecode: "FMG2024",
    siteName: "FMG Repair Services (Littlehampton)",
    siteCode: "NW_LT",
    noResponse: 2,
    detractor: 0,
    passive: 1,
    promotor: 1,
    groupingValue: "Group B",
    totalResponses: 8,
    totalRows: 8,
    dateStarted: "2024-02-01T09:00:00Z",
    dateEnded: "2024-05-31T16:00:00Z",
    npsScore: 50,
    monthYearGroupings: [
      {
        name: "2024/27",
        value: 3
      },
      {
        name: "2024/28",
        value: 1
      },
      {
        name: "2025/06",
        value: 5
      },
      {
        name: "2025/40",
        value: 2
      },
      {
        name: "2025/41",
        value: 1
      },
      {
        name: "2025/45",
        value: 4
      }
    ],
    repairerGroup: "NATIONWIDE"
  },
  {
    schemecode: "ITD2024",
    siteName: "IT_DIRECT",
    siteCode: "ITDRCT",
    noResponse: 2,
    detractor: 0,
    passive: 0,
    promotor: 2,
    groupingValue: "Group C",
    totalResponses: 3,
    totalRows: 3,
    dateStarted: "2024-03-01T10:00:00Z",
    dateEnded: "2024-06-30T15:00:00Z",
    npsScore: 100,
    monthYearGroupings: [
      {
        name: "2024/27",
        value: 1
      },
      {
        name: "2024/28",
        value: 3
      },
      {
        name: "2025/06",
        value: 4
      },
      {
        name: "2025/40",
        value: 2
      },
      {
        name: "2025/41",
        value: 1
      },
      {
        name: "2025/45",
        value: 5
      }
    ],
    repairerGroup: "IT_DIRECT"
  },
  {
    schemecode: "TST2025",
    siteName: "TestAdmiral18072025_2",
    siteCode: "EWWEWE",
    noResponse: 2,
    detractor: 1,
    passive: 0,
    promotor: 1,
    groupingValue: "Group D",
    totalResponses: 2,
    totalRows: 2,
    dateStarted: "2025-01-01T08:30:00Z",
    dateEnded: "2025-07-18T17:30:00Z",
    npsScore: 0,
    monthYearGroupings: [
      {
        name: "2024/27",
        value: 6
      },
      {
        name: "2024/28",
        value: 2
      },
      {
        name: "2025/06",
        value: 1
      },
      {
        name: "2025/40",
        value: 3
      },
      {
        name: "2025/41",
        value: 4
      },
      {
        name: "2025/45",
        value: 1
      }
    ],
    repairerGroup: "TESTADMIRAL18072025_"
  }
]